import stravaConnectOrange from "@/assets/strava/btn_strava_connect_with_orange.svg";
import { cn } from "@/lib/utils";
import { useToast } from "@/hooks/use-toast";
import { useConnectStrava } from "@/api/strava";

interface StravaConnectButtonProps {
  className?: string;
  onConnected?: () => void;
}

// Official "Connect with Strava" button. Per Strava's brand guidelines the
// artwork must be used unmodified and the button must initiate the OAuth
// connect flow, so we render the supplied asset as-is and trigger the connect.
export const StravaConnectButton = ({
  className,
  onConnected,
}: StravaConnectButtonProps) => {
  const connectStrava = useConnectStrava();
  const { toast } = useToast();

  const handleConnect = () => {
    connectStrava.mutate(undefined, {
      onSuccess: () => {
        toast({
          title: "Connected to Strava",
          description: "Your runs will start importing automatically.",
        });
        onConnected?.();
      },
      onError: (error: any) =>
        toast({
          variant: "destructive",
          title: "Couldn't connect to Strava",
          description: error?.message ?? "Please try again.",
        }),
    });
  };

  return (
    <button
      type="button"
      onClick={handleConnect}
      disabled={connectStrava.isPending}
      aria-label="Connect with Strava"
      className={cn(
        "inline-block transition-opacity hover:opacity-90 disabled:opacity-60",
        className,
      )}
    >
      <img
        src={stravaConnectOrange}
        alt="Connect with Strava"
        className="h-10 w-auto"
      />
    </button>
  );
};
